// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jump-to-group[data-v-e5dd8b5e]{position:relative;z-index:20}.jump-to-group-popover[data-v-e5dd8b5e]{max-height:calc(100vh - 200px);display:flex;flex-direction:column}.jump-to-group-header[data-v-e5dd8b5e]{flex-shrink:0;background-color:#fafafa}.theme--dark .jump-to-group-header[data-v-e5dd8b5e]{background-color:#2d2d2d}.jump-to-group-content[data-v-e5dd8b5e]{overflow-y:auto;flex:1 1 auto;max-height:calc(100vh - 340px)}", ""]);
// Exports
module.exports = exports;
